import React, { useEffect } from "react";
import { generalIcons } from "../utils/constants";
import { formatNumber, getValidatorImg, handleInputChange } from "../utils/helper";
import BeatLoaderComponent from "./loader/BeatLoaderComponent";

function Unstake({
    availableBalance,
    inputValue,
    setInputValue,
    IsFetchingWalletInfo,
    setIsUnStakeAmountConfirmed,
    isConfirmDisabled, setIsConfirmDisabled,selectedValidator,
    setIsMaxSelected,
    isFetchingUnstakeBalance,
    setIsTermsAgreed,
    isTermsAgreed
}) {
    const handleMaxClick = () => {
        setInputValue(availableBalance > 0 ? availableBalance : "");
        setIsMaxSelected(true)
        if(isTermsAgreed){
            setIsConfirmDisabled(false)
        }
    };

    useEffect(() => {
        if (isTermsAgreed && Number(inputValue) > 0) {
            setIsConfirmDisabled(false);
        } else {
            setIsConfirmDisabled(true);
        }
    }, [isTermsAgreed]);

    return (
        <div className="flex items-center justify-center w-full h-auto xsm:h-full px-4 forMobile">
            <div className="max-w-[1200px] w-full bg-[#121212] border-[#1A1A1ACC] rounded-3xl pt-6 pb-11 md:py-10 px-4 md:px-9 mx-auto">
                <div className='grid lg:grid-cols-2 gap-6 md:gap-8'>
                    <div className="flex flex-col items-center md:items-start text-center md:text-left">
                        <h4 className="text-textcolor text-xxl md:text-[34px] leading-none font-bold md:font-semibold capitalize mb-3">
                            Enter Unstake Amount
                        </h4>
                        <p className="text-xsm md:text-sm font-normal text-dim/50 max-w-[350px] mb-6 md:mb-0">
                        You have to Unstake certain amount of $VANRY to confirm
                        </p>
                        <div className="my-8 bg-white/[0.04] h-[1px] w-[88px] hidden md:block"></div>
                        <div className="flex items-center flex-col md:flex-row gap-4">
                            <div className="flex items-center justify-center p-3 md:p-[10px] w-[59px] h-[59px] md:w-[74px] md:h-[74px] rounded-2xl bg-[#010101]">
                                <img src={getValidatorImg(selectedValidator?.name)} alt="" className="" />
                            </div>
                            <div className="flex flex-col gap-[10px]">
                                <h4 className="text-sm md:text-xl font-medium leading-4 md:leading-6 text-primaryWhite">
                                    {selectedValidator?.name}
                                </h4>
                                <ul className="flex space-x-2 md:space-x-4">
                                    {/* <li className="text-sm md:text-base font-normal leading-7 text-primaryWhite/50">
                                        <span className="text-green mr-1">
                                            {selectedValidator?.performance ? selectedValidator?.performance : '0%'}
                                        </span>
                                        Performance
                                    </li> */}
                                    <li className="text-sm md:text-base font-normal leading-7 text-primaryWhite/50">
                                        <span className="text-green mr-1">
                                        {selectedValidator?.commission ? (selectedValidator?.commission * 100) + "%" : '0%'}
                                        </span>
                                        Commission
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <div className="bg-[#1A1A1A] border-[1.5px] border-white/[0.02] flex flex-col gap-3 md:gap-4 h-auto justify-between min-h-[120px] px-[18px] md:px-6 py-4 rounded-2xl w-full">
                            <div className="flex flex-col gap-3 md:gap-4">
                                <div className="flex items-center justify-between">
                                    <h4 className="text-sm leading-6 text-dim/40 -tracking-03">
                                        Unstake Amount
                                    </h4>
                                    <div className="relative w-[30%] flex justify-end">
                                        <div className="flex items-center">
                                            <div className="flex items-center justify-center w-5 h-5 mr-1">
                                                {generalIcons.vanry}
                                            </div>
                                            $VANRY
                                        </div>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    name="amount"
                                    className="text-[28px] font-semibold -tracking-08 leading-[30px] md:leading-[42px] w-full"
                                    placeholder="0"
                                    autoComplete="off"
                                    value={inputValue}
                                    onChange={(e)=>handleInputChange(e, availableBalance,setInputValue, setIsConfirmDisabled, setIsMaxSelected, isTermsAgreed)}
                                />
                            </div>
                            <div className="flex items-center justify-between gap-2">
                                <div className="flex text-sm font-normal text-dim/50">
                                    Balance:
                                    {(IsFetchingWalletInfo || isFetchingUnstakeBalance )&& (
                                        <BeatLoaderComponent size={7} />
                                    )}
                                    {(!IsFetchingWalletInfo && !isFetchingUnstakeBalance) && (
                                        <span className="font-semibold ml-1">
                                            {availableBalance
                                                ? formatNumber(availableBalance)
                                                : 0}
                                        </span>
                                    )}
                                </div>
                                <button
                                    className="flex border-[1.5px] border-tagcolor bg-tagcolor/[0.20] rounded-full px-3 py-1"
                                    onClick={handleMaxClick}
                                >
                                    <span className="text-xsm font-medium text-dim tracking-[-.1px]">
                                        Max
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="flex text-[16px] mt-5 md:px-2 gap-2 justify-left items-left">
                            <div className="inline-flex items-center">
                                <label
                                    className="flex items-center cursor-pointer relative"
                                    htmlFor="check-with-link"
                                >
                                    <input
                                        type="checkbox"
                                        readOnly checked={isTermsAgreed} onClick={()=>setIsTermsAgreed(!isTermsAgreed)}
                                        className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#03D9AF] checked:border-[#03D9AF]"
                                        id="check-with-link"
                                    />
                                    <span className="absolute text-white opacity-0 bg-[#03D9AF] peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-3.5 w-3.5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                            stroke="currentColor"
                                            strokeWidth="1"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            ></path>
                                        </svg>
                                    </span>
                                </label>
                                <label
                                    className="cursor-default ml-2 text-slate-600 text-sm"
                                    htmlFor="check-with-link"
                                >
                                    <p>
                                    I have read and agreed to Vanar Staking <a href={`${window?.location?.origin}/terms`} target="blank" className="underline text-[#03D9AF]">Teams & Conditions</a>
                                    </p>
                                </label>
                            </div>

                        </div>
                        <div className="mt-5 md:mt-[30px]">
                            <button
                                disabled={isConfirmDisabled}
                                onClick={()=> setIsUnStakeAmountConfirmed(true)}
                                type="button"
                                className={`${isConfirmDisabled
                                    ? "opacity-50 cursor-not-allowed"
                                    : "cursor-pointer"
                                    }inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Unstake;
